export enum AccordionFilterEvents {
  filterChanged = 'filterChanged',
}

export const accordionFilterEvents = [AccordionFilterEvents.filterChanged]
